import { Button } from "@fluentui/react-components";
import { useNavigate } from "react-router-dom";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "12px",
        textAlign: "center",
        padding: "24px",
      }}
    >
      <h1 style={{ margin: 0 }}>404</h1>
      <p style={{ margin: 0 }}>Page not found</p>
      <Button appearance="primary" onClick={() => navigate("/login", { replace: true })}>
        Back to login
      </Button>
    </div>
  );
}